import { gql } from '@apollo/client'

export const FRAGMENT_WORKSPACE = gql`
  fragment FragmentWorkspace on Workspace {
    id
    canGenerateBriefing
    canShowGenerateBriefingButton
    taxonomyType
  }
`
